<template>
    <footer id="footer" class="footer">
      <div class="footer__top">
        <div class="footer__top-name">
          <h2>Independent Arbitrator and Mediator
          </h2>
          <h2>Julie G. Hopkins
          </h2>
        </div>
        <div class="footer__top-contact">
          <div class="footer__top-contact--address">
            <p>10th Floor – 888 3rd Street SW</p>
            <p>Banker's Hall, West Tower</p>
            <p>Calgary, AB, T2P 5C5</p>
          </div>
          <div class="footer__top-contact--email">
            <span>
              <svg xmlns="http://www.w3.org/2000/svg" width="19" height="14" viewBox="0 0 19 14" fill="none">
                <path d="M1.1875 3.47083L9.5 9.08542L17.8125 3.47083V1.16667H1.1875V3.47083ZM17.8125 4.88542L9.5 10.5L1.1875 4.88542V12.8333H17.8125V4.88542ZM0 12.8333V4.08333V1.16667V0H1.1875H17.8125H19V1.16667V4.08333V12.8333V14H17.8125H1.1875H0V12.8333Z" fill="white"/>
              </svg>
              <a href="mailto:Julie.Hopkins@jghopkins.com">Julie.Hopkins@jghopkins.com</a>
            </span>
            <span>
              <svg xmlns="http://www.w3.org/2000/svg" width="19" height="20" viewBox="0 0 19 20" fill="none">
                <path d="M11.1959 14.1414L10.4055 13.685C8.49805 12.5865 6.91348 10.9982 5.81504 9.09453L5.35859 8.3041L6.00059 7.66211L7.51094 6.15176L5.78906 1.84336L1.1875 2.67832V2.875C1.1875 11.399 8.10098 18.3125 16.625 18.3125H16.8217L17.6566 13.7109L13.3482 11.9854L11.8379 13.4957L11.1959 14.1414ZM13.0625 10.5938L19 12.9688L17.8125 19.5H16.625C7.44414 19.5 0 12.0559 0 2.875V1.6875L6.53125 0.5L8.90625 6.4375L6.84297 8.50078C7.8375 10.2264 9.27363 11.6625 10.9992 12.657L13.0625 10.5938Z" fill="white"/>
              </svg>
              <a href="tel:(403) 835-1357">(403) 835-1357</a>
            </span>
          </div>
        </div>
      </div>
      <div class="footer__bottom">
        <img src="../assets/wac-logo.png" alt="Western Arbitration Chambers" width="176" />
        <p>Copyright &copy; {{currentYear}} J. G. Hopkins Professional Corporation</p>
      </div>
    </footer>
</template>

<script>
export default {
  name: 'Footer',
  props: {},
  computed: {
    currentYear: function () {
      return new Date().getFullYear()
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  padding-top: 2em;
  padding-bottom: 1rem;
  &__top {
    background: url('../assets/footer.jpg');
    background-size: cover;
    background-position: 8% top;
    margin-bottom: 1rem;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    color: $white;
    text-align: left;
    padding: 5.625rem 1.5rem 4rem;

    &-name {
      h2 {
        &:first-child {
          font-size: 1rem;
          font-weight: 700;
          line-height: normal;
          text-transform: uppercase;
          margin-bottom: 1rem;
  
          &:before {
            top: -30px;
            background: $primary-accent;
            width: 90px;
          }
        }
  
        &:last-child {
          font-size: 1.75rem;
          font-weight: 800;
          line-height: 48px;
          text-transform: uppercase;
          margin-bottom: 1.5rem;
        }
      }
    }

    &-contact {
      display: flex;
      flex-direction: column;

      &--address {
        p {
          font-size: 1rem;
          font-weight: 350;
          line-height: 24px;
          margin-bottom: 0;
        }
        margin-bottom: 1.875rem;
      }

      &--email {
        span {
          display: flex;
          align-items: center;

          svg {
            margin-right: 0.75rem;
            margin-top: -0.5rem;
          }
        }
        a {
          font-size: 1rem;
          font-weight: 350;
          line-height: 20px;
          margin-bottom: 0.5rem;
          color: $white;
          text-decoration: none;

          &:hover {
            text-decoration: none;
          }
        }
      }


      
    }
  }
  &__bottom {
    display: flex;
    flex-direction: column;
    align-items: center;
    img {
      display: block;
      width: 200px;
      margin-bottom: 1.5rem;
    }
    p {
      text-align: center;
      width: 60% ;
      margin: 0 auto;
    }
  }
}
@media screen and (min-width: 768px) {
  .footer {
    &__top {
      padding-left: 10%;
    }
  }
}
@media only screen and (min-width: 1024px) {
  .footer {
    padding-top: 3rem;
    &__top {
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      padding-top: 7.5rem ;

      &-name {
        margin-right: 3rem;
        h2 {
          &:first-child {
            font-size: 1.25rem;
            &:before {
              top: -32px;
            }
          }
    
          &:last-child {
            font-size: 2.25rem;
          }
        }
      }

      &-contact {
        margin-left: 2rem;
        flex-direction: row;

        &--address {
          margin-right: 3rem;
        }
      }
    }
    &__bottom {
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin: 0 4rem;
      img {
        margin-bottom: 0;
      }
      p {
        width: auto;
        margin: 0;
      }
    }
  }
}
</style>
